import gpio from "gpio";

const SETTARGET = 0xC0;

class JRKG2 {
	constructor(chip_address = 0x0B) {
		this.__chip_address = chip_address;
	}
	setTarget(target) {
		if (target > 4095) target = 4095;
		this.commandW7((SETTARGET | (target & 0x1F)), target >> 5);
	}
	commandW7(cmd, val) {
		gpio.i2c[1].writeBlockData(this.__chip_address, new Uint8Array([cmd, val & 0x7F]));
	}
}

export default JRKG2;